











































import {Component} from 'vue-property-decorator';
import {VFormData} from '@/utils/VFormData';
import {ModuleAuth} from '@/store/modules/AuthModule';
import ChunForm from '@/mixins/ChunForm';

interface ILoginData {
  email: string;
  password: string;
}

@Component({})
export default class LoginForm extends ChunForm {
  loading: boolean = false;
  passwordHidden: boolean = true;
  formData: VFormData<ILoginData> = new VFormData<ILoginData>({
    email: '',
    password: ''
  });


  async submit() {
    try {
      this.loading = true;
      const {success, response} = await ModuleAuth.login(this.formData.data);
      if (!success) {
        this.extractError(response);
        return;
      }
      await this.$router.push({name: 'dashboard.overview'});

    } finally {
      this.loading = false;
    }
  }
}
